import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=4d1efa0e&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=js&"
export * from "./Legal.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=4d1efa0e&prod&scoped=true&lang=css&"
import style1 from "./Legal.vue?vue&type=style&index=1&id=4d1efa0e&prod&lang=css&"
import style2 from "./Legal.vue?vue&type=style&index=2&id=4d1efa0e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1efa0e",
  null
  
)

export default component.exports